"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PdsDatePickerDialog = void 0;
var react_1 = __importDefault(require("react"));
var react_utils_1 = require("../utils/react-utils");
var web_component_1 = require("./web-component");
function PdsDatePickerDialog(props) {
    return (react_1.default.createElement(web_component_1.WebComponent, { tag: "pds-date-picker-dialog", attributes: {
            class: react_utils_1.toAttribute(props.className),
            name: react_utils_1.toAttribute(props.name),
            'data-mindate': react_utils_1.toAttribute(props.dataMindate),
            'data-maxdate': react_utils_1.toAttribute(props.dataMaxdate),
            'data-return-focus': react_utils_1.toAttribute(props.dataReturnFocus),
            'data-is-multi-select': react_utils_1.toAttribute(props.dataIsMultiSelect),
            'data-label-text': react_utils_1.toAttribute(props.dataLabelText),
            'data-is-form-element': react_utils_1.toAttribute(props.dataIsFormElement),
            month: react_utils_1.toAttribute(props.month),
            year: react_utils_1.toAttribute(props.year)
        }, properties: {
            value: props.value
        }, listeners: {
            'pds-date-change-event': function (event) {
                props.pdsDateChangeEvent(event.target.value);
            },
            'pds-remove-dialog': function () {
                if (props.pdsRemoveDialog != null) {
                    props.pdsRemoveDialog();
                }
            }
        } }));
}
exports.PdsDatePickerDialog = PdsDatePickerDialog;

//# sourceMappingURL=pds-date-picker-dialog.js.map
